import React from "react";
import { HashRouter } from "react-router-dom";
import { store, persistor } from "./store";
import Router from "./Router";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { config as i18nextConfig } from "../../translations";

i18next.init(i18nextConfig);

function App() {
  return (
    <React.StrictMode>
      <div className="App">
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <HashRouter basename="/harp">
              <I18nextProvider i18n={i18next}>
                <Router />
              </I18nextProvider>
            </HashRouter>
          </PersistGate>
        </Provider>
      </div>
    </React.StrictMode>
  );
}

/* Below code is to redirect to basename: /harp 
/harp is getting used to redirect from the Novascotia landing page.
*/
if (window.location.pathname === "/" && window.location?.hash === "") {
  window.location.replace("/#/harp");
}

export default App;
